import * as Yup from 'yup';

const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}?\)?[-.\s]?)?(\d{1,4}[-.\s]?){1,4}\d{1,4}$/;

const emailValidationRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// "+123 456 7890",
// "(123) 456-7890",
// "123-456-7890",
// "123.456.7890",
// "123 456 7890",
// "1234567890",
// "123-4567-890"

/* eslint-disable no-useless-escape */
export const ValidateLogin = Yup.object().shape({
  email: Yup.string()
    .transform((v) => (typeof v === 'string' ? v.trim().toLowerCase() : v))
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(255, 'Email ID is too long')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  password: Yup.string()
    .required('Password cannot be empty')
    .min(8, 'Password must be at least 8 characters')
    .max(128, 'Password cannot exceed 128 characters')
});

export const ValidateForgotPassword = Yup.object().shape({
  email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty')
});

export const ValidateResetPassword = Yup.object().shape({
  password: Yup.string()
    .required('Password cannot be empty')
    .min(8, 'Password should at least contain 8 characters')
    .max(16, 'Password cannot exceed 16 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{1,})/,
      'Password must contain at least 1 digit, 1 lowercase letter,1 uppercase letter and 1 special character'
    ),
  password_confirmation: Yup.string()
    .required('Confirm Password cannot be empty')
    .oneOf([Yup.ref('password'), null], 'Password mismatch! Retry')
});

export const ValidateDepartment = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Department Name should at least contain 2 characters')
    .max(64, 'Department Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Department Name should contain only Alphabets')
    .required('Department Name cannot be empty')
});

export const ValidateUOM = Yup.object().shape({
  name: Yup.string()
    .min(4, 'UOM Name should atleast contain 4 characters')
    .max(64, 'UOM Name should not exceed 64 characters')
    .matches(/^[a-zA-Z ]*$/, 'Enter a valid UOM')
    .required('UOM Name cannot be empty'),
  short_name: Yup.string()
    .min(3, 'UOM Short Name should atleast contain 3 characters')
    .max(4, 'UOM Short Name should not exceed 4 characters')
    .matches(/^[a-zA-Z]*$/, 'Enter a valid UOM Short Name')
    .required('UOM Short Name cannot be empty')
});

export const ValidateCurrencyAdd = Yup.object().shape({
  name: Yup.string().required('Currency Name cannot be empty')
});

export const ValidateCompany = Yup.object().shape({
  name: Yup.string()
    .max(64, 'Company Name cannot exceed 64 characters')
    .min(2, 'Company Name should at least contain 2 characters')
    .required('Company Name cannot be empty')
});

export const ValidateRole = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Role should at least contain 2 characters')
    .max(64, 'Role Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Role Name should contain only Alphabets')
    .required('Role Name cannot be empty')
});

export const ValidateProfile = Yup.object().shape({
  name: Yup.string()
    .max(64, 'Name cannot exceed 64 characters')
    .min(2, 'Name should at least contain 2 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Name should contain only Alphabets')
    .required('Name cannot be empty'),
  email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty')
});

export const ValidateOffice = Yup.object().shape({
  address_type: Yup.string()
    .min(2, 'Address Type should at least contain 2 characters')
    .max(64, 'Address Type cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'First Name should contain only Alphabets')
    .required('Address Type cannot be empty'),
  short_code: Yup.string()
    .min(3, 'Short Code should contain exactly 3 characters')
    .max(3, 'Short Code should contain exactly 3 characters')
    .matches(/^[A-Za-z]+$/, 'Short Code should contain only alphabets')
    .required('Short Code cannot be empty'),
  full_address: Yup.string()
    .min(8, 'Full Address should atleast contain 8 characters')
    .max(264, 'Full Address should not exceed 264 characters')
    .required('Full Address cannot be empty')
});

export const ValidateClient = Yup.object().shape({
  company_id: Yup.object().required('Company Name cannot be empty'),
  first_name: Yup.string()
    .min(2, 'First Name should at least contain 2 characters')
    .max(64, 'First Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'First Name should contain only Alphabets')
    .required('First Name cannot be empty'),
  last_name: Yup.string()
    .min(2, 'Last Name should at least contain 2 characters')
    .max(64, 'Last Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Last Name should contain only Alphabets')
    .required('Last Name cannot be empty'),
  email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  secondary_email: Yup.array().of(
    Yup.string()
      .max(64, 'Email ID cannot exceed 64 characters')
      .min(5, 'Email ID should at least contain 5 characters')
      .matches(emailValidationRegex, 'Enter a valid Email ID')
      // Mirrors the backend rule — the primary address must not be repeated
      // here, otherwise the client would be mailed twice.
      .test(
        'not-primary-email',
        'Secondary Email cannot be the same as the Email ID',
        function checkPrimary(value) {
          const primary = this.options.context && this.options.context.email;
          return !value || !primary || value.toLowerCase() !== primary.toLowerCase();
        }
      )
  ),
  address_1: Yup.string()
    .min(8, 'Address should atleast contain 8 characters')
    .max(128, 'Address should not exceed 128 characters'),
  address_2: Yup.string()
    .min(8, 'Address should atleast contain 8 characters')
    .max(128, 'Address should not exceed 128 characters'),
  city: Yup.string()
    .max(32, 'City cannot exceed 32 characters')
    .min(4, 'City should at least contain 4 characters')
    .matches(/^[a-zA-Z\s]+$/, 'City should contain only Alphabets'),
  state_id: Yup.object().nullable(),
  country_id: Yup.object().nullable(),
  phone: Yup.string()
    .max(16, 'Phone Number cannot exceed 16 characters')
    .min(8, 'Phone Number should at least contain 8 characters')
    .matches(phoneRegex, 'Enter a valid phone number'),
  department_id: Yup.array().min(1, 'At least one department is required'),
  currency_id: Yup.object().required('Currency cannot be empty'),
  payment_method_id: Yup.array(),
  postal_code: Yup.string()
    .min(1, 'Postal Code should at least contain 1 characters')
    .max(14, 'Postal Code cannot exceed 14 characters')
});

export const ValidateUserAdd = Yup.object().shape({
  name: Yup.string()
    .min(2, 'User Name should at least contain 2 characters')
    .max(64, 'User Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'User Name should contain only Alphabets')
    .required('User Name cannot be empty'),
  email: Yup.string()
    .transform((v) => (typeof v === 'string' ? v.trim().toLowerCase() : v))
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(255, 'Email ID is too long')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  department: Yup.object().required('Department cannot be empty')
});

export const ValidateSettingsMail = Yup.object().shape({
  // from_email: Yup.string()
  //   .matches(emailValidationRegex, 'Enter a valid Email ID')
  //   .max(64, 'Email ID cannot exceed 64 characters')
  //   .min(5, 'Email ID should at least contain 5 characters')
  //   .required('Email ID cannot be empty'),
  cc_mail: Yup.array()
    .of(
      Yup.string()
        .matches(emailValidationRegex, 'Enter a valid Email ID')
        .max(64, 'Email ID cannot exceed 64 characters')
        .min(5, 'Email ID should at least contain 5 characters')
    )
    .min(1, 'At least one email is required'),
  reply_to_mail: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty')
});

export const ValidateChangePassword = Yup.object().shape({
  current_password: Yup.string().required('Current Password cannot be empty'),
  password: Yup.string()
    .required('New Password cannot be empty')
    .matches(/^\S+$/, 'New Password cannot contain spaces')
    .min(8, 'New Password should contain minimum 8 characters')
    .max(16, 'New Password cannot exceed 16 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{1,})/,
      'New Password must contain at least 1 digit, 1 lowercase letter,1 uppercase letter and 1 special character'
    ),
  password_confirmation: Yup.string()
    .required('Confirm Password cannot be empty')
    .oneOf([Yup.ref('password'), null], 'Confirm Password does not match the New Password')
});

export const ValidateBankDetails = Yup.object().shape({
  gstin: Yup.string()
    .max(15, 'GSTIN cannot exceed 15 characters')
    .min(15, 'GSTIN should at least contain 15 characters')
    .matches(/^[a-zA-Z0-9]+$/, 'GSTIN must be contain only alphabets and numbers')
    .required('GSTIN cannot be empty'),
  import_export_code: Yup.string()
    .max(10, 'Import Export Code cannot exceed 10 characters')
    .min(8, 'Import Export Code should at least contain 8 characters')
    .matches(/^[a-zA-Z0-9]+$/, 'Import Export Code must be contain only alphabets and numbers.')
    .required('Import Export Code cannot be empty'),
  satellite_station: Yup.string()
    .max(64, 'Satellite Station cannot exceed 64 characters')
    .min(6, 'Satellite Station should at least contain 6 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Please enter a valid Satellite Station')
    .required('Satellite Station cannot be empty'),
  destination: Yup.string()
    .max(32, 'Destination cannot exceed 32 characters')
    .min(2, 'Destination should at least contain 2 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Please enter a valid Destination')
    .required('Destination cannot be empty'),
  tax_id: Yup.string()
    .max(16, 'Tax ID cannot exceed 11 characters')
    .min(8, 'Tax ID should at least contain 10 characters')
    .matches(/^[0-9\-]+$/, 'Tax ID must contain only numbers and hyphens.'),
  note: Yup.string()
    .max(264, 'Note cannot exceed 264 characters')
    .min(2, 'Note should at least contain 2 characters')
    .required('Note cannot be empty'),
  phone: Yup.string()
    .max(16, 'Phone Number cannot exceed 16 characters')
    .min(4, 'Phone Number should at least contain 4 characters')
    .matches(phoneRegex, 'Please enter a valid Phone Number')
    .required('Phone Number cannot be empty'),
  beneficiary_bank_account: Yup.string()
    .matches(/^[0-9]+$/, 'Please enter a valid Bank Account Number')
    .max(32, 'Bank Account Number cannot exceed 32 characters')
    .min(4, 'Bank Account Number should at least contain 4 characters')
    .required('Bank Account Number cannot be empty'),
  beneficiary_bank_name: Yup.string()
    .min(2, 'Bank Name should atleast contain 2 characters')
    .max(64, 'Bank Name should not exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Please enter a valid Bank Name')
    .required('Bank Name cannot be empty'),
  bank_address: Yup.string()
    .min(8, 'Bank Address should atleast contain 8 characters')
    .max(128, 'Bank Address should not exceed 128 characters')
    .required('Bank Address cannot be empty'),
  bank_city: Yup.string()
    .max(32, 'Bank City cannot exceed 32 characters')
    .min(2, 'Bank City should at least contain 2 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Please enter a valid Bank Name')
    .required('Bank City cannot be empty'),
  bank_state: Yup.object().required('State cannot be empty'),
  bank_country: Yup.object().required('Country cannot be empty'),
  bank_phone: Yup.string()
    .max(16, 'Bank Phone Number cannot exceed 16 characters')
    .min(4, 'Bank Phone Number should at least contain 4 characters')
    .matches(phoneRegex, 'Enter a valid Bank phone number')
    .required('Bank Phone Number cannot be empty'),
  ifsc: Yup.string()
    .max(16, 'Bank IFSC Code cannot exceed 16 characters')
    .min(4, 'Bank IFSC Code should at least contain 4 characters')
    .matches(/^[a-zA-Z0-9]+$/, 'Please enter a valid Bank IFSC Code')
    .required('Bank IFSC Code cannot be empty'),
  bank_routing_shift: Yup.string()
    .max(16, 'Bank Routing Shift cannot exceed 16 characters')
    .min(4, 'Bank Routing Shift should at least contain 4 characters')
    .matches(/^[a-zA-Z0-9]+$/, 'Please enter a valid Bank Routing Shift')
    .required('Bank Routing Shift cannot be empty'),
  email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  bank_zip: Yup.string()
    .max(14, 'Bank ZIP Number cannot exceed 14 characters')
    .min(1, 'Bank ZIP Number should at least contain 1 characters')
    .required('Bank ZIP Number cannot be empty')
});

export const ValidatePaymentRequest = Yup.object().shape({
  office_id: Yup.object().required('Office Name cannot be empty'),
  invoice_date: Yup.date().required('Invoice Date cannot be empty'),
  request_type_id: Yup.string().required('Please select a payment request type'),
  primary_email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  invoice_email: Yup.array().of(
    Yup.string()
      .max(64, 'Email ID cannot exceed 64 characters')
      .min(5, 'Email ID should at least contain 5 characters')
      .matches(emailValidationRegex, 'Enter a valid Email ID')
  ),
  department_id: Yup.array().min(1, 'At least one department is required'),
  payment_method_id: Yup.array(),
  client_id: Yup.object().required('Client cannot be empty'),
  company_id: Yup.object().required('Company cannot be empty'),
  currency_id: Yup.object().required('Currency cannot be empty'),
  // client_approval_date: Yup.date().required('Client Approval Date cannot be empty'),
  due_date: Yup.date().required('Due Date cannot be empty'),
  purchase_value: Yup.string().when('purchase_type', {
    is: (val) => val === 'po_number',
    then: (schema) => schema.trim().required('Purchase Order Number is required'),
    otherwise: (schema) =>
      schema.when('purchase_type', {
        is: (val) => val === 'contract_date',
        // eslint-disable-next-line no-shadow
        then: (schema) => schema.required('Contract Date is required'),
        // eslint-disable-next-line no-shadow
        otherwise: (schema) => schema.notRequired()
      })
  }),
  // purchase_value: Yup.string().when('purchase_type', {
  //   is: (value) => value === 'po_number',
  //   then: (schema) =>
  //     schema
  //       .min(4, 'Purchase Number should not exceed 4 characters')
  //       .max(264, 'Purchase Number should not exceed 264 characters')
  //       .required('Purchase Number cannot be empty'),
  //   otherwise: (schema) => schema.required('Contract Date cannot be empty')
  // }),
  invoice_details: Yup.array().of(
    Yup.object().shape({
      services_from: Yup.date().required('Service From date cannot be empty'),
      services_to: Yup.date().required('Service To date cannot be empty'),
      services: Yup.array().of(
        Yup.object().shape({
          service_description: Yup.string()
            .max(64, 'Description cannot exceed 64 characters')
            .min(8, 'Description should at least contain 8 characters')
            .required('Description cannot be empty'),
          quantity: Yup.number()
            .typeError('Quantity must be a number')
            .min(0.01, 'Quantity must be greater than 0')
            .max(99999.99, 'Quantity cannot exceed 99999.99')
            .test(
              'max-2-decimals',
              'Quantity can have at most 2 decimal places',
              (v) => v === undefined || /^\d+(\.\d{1,2})?$/.test(String(v))
            )
            .required('Quantity cannot be empty'),
          unit_measurement_id: Yup.object().required('UOM cannot be empty'),
          rate: Yup.number()
            // .matches(/^[0-9]+$/, 'Rate should only contain numbers')
            .max(99999999, 'Rate cannot exceed 8 characters')
            .min(1, 'Rate should at least contain 1 characters')
            .required('Rate cannot be empty')
          // amount: Yup.number()
          //   .required('Amount cannot be empty')
          //   .min(0, 'Amount must be a positive number')
        })
      )
    })
  )
});

export const ValidateAuthorizeCard = Yup.object().shape({
  AUTHORIZE_MODE: Yup.string()
    .oneOf(['sandbox', 'live'], 'Invalid Authorize mode')
    .required('Authorize mode is required'),
  AUTHORIZE_SANDBOX_LOGIN_ID: Yup.string().when('AUTHORIZE_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Authorize Sandbox Login ID should at least contain 4 characters')
        .max(264, 'Authorize Sandbox Login ID should not exceed 264 characters')
        .required('Authorize Sandbox Login ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  AUTHORIZE_SANDBOX_TRANSACTION_KEY: Yup.string().when('AUTHORIZE_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Authorize Sandbox Transaction Key should at least contain 4 characters')
        .max(264, 'Authorize Sandbox Transaction Key should not exceed 264 characters')
        .required('Authorize Sandbox Transaction Key cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  AUTHORIZE_LIVE_LOGIN_ID: Yup.string().when('AUTHORIZE_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Authorize Live Login ID should at least contain 4 characters')
        .max(264, 'Authorize Live Login ID should not exceed 264 characters')
        .required('Authorize Live Login ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  AUTHORIZE_LIVE_TRANSACTION_KEY: Yup.string().when('AUTHORIZE_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Authorize Live Transaction Key should at least contain 4 characters')
        .max(264, 'Authorize Live Transaction Key should not exceed 264 characters')
        .required('Authorize Live Transaction Key cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  })
});

export const ValidateStripe = Yup.object().shape({
  STRIPE_MODE: Yup.string()
    .oneOf(['sandbox', 'live'], 'Invalid Stripe mode')
    .required('Stripe mode is required'),
  STRIPE_SANDBOX_KEY: Yup.string().when('STRIPE_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Stripe Sandbox Key should not exceed 4 characters')
        .max(264, 'Stripe Sandbox Key should not exceed 264 characters')
        .required('Stripe Sandbox Key cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  STRIPE_SANDBOX_SECRET: Yup.string().when('STRIPE_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Stripe Sandbox Secret should not exceed 4 characters')
        .max(264, 'Stripe Sandbox Secret should not exceed 264 characters')
        .required('Stripe Sandbox Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  STRIPE_LIVE_KEY: Yup.string().when('STRIPE_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Stripe Live Key should not exceed 4 characters')
        .max(264, 'Stripe Live Key should not exceed 264 characters')
        .required('Stripe Live Key cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  STRIPE_LIVE_SECRET: Yup.string().when('STRIPE_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Stripe Live Secret should not exceed 4 characters')
        .max(264, 'Stripe Live Secret should not exceed 264 characters')
        .required('Stripe Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  })
});

export const ValidatePayPal = Yup.object().shape({
  PAYPAL_MODE: Yup.string()
    .oneOf(['sandbox', 'live'], 'Invalid PayPal mode')
    .required('PayPal mode is required'),
  PAYPAL_SANDBOX_CLIENT_ID: Yup.string().when('PAYPAL_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'PayPal Sandbox Client ID should not exceed 4 characters')
        .max(264, 'PayPal Sandbox Client ID should not exceed 264 characters')
        .required('Sandbox Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  PAYPAL_SANDBOX_CLIENT_SECRET: Yup.string().when('PAYPAL_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'PayPal Sandbox Client Secret should not exceed 4 characters')
        .max(264, 'PayPal Sandbox Client Secret should not exceed 264 characters')
        .required('PayPal Sandbox Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  PAYPAL_LIVE_CLIENT_ID: Yup.string().when('PAYPAL_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'PayPal Live Client ID should not exceed 4 characters')
        .max(264, 'PayPal Live Client ID should not exceed 264 characters')
        .required('Live Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  PAYPAL_LIVE_CLIENT_SECRET: Yup.string().when('PAYPAL_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'PayPal Sandbox Client Secret should not exceed 4 characters')
        .max(264, 'PayPal Sandbox Client Secret should not exceed 264 characters')
        .required('Live Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  // Optional: required only to enable signature-verified webhooks. Capped but
  // not mandatory, so saving credentials without a webhook id still works.
  PAYPAL_SANDBOX_WEBHOOK_ID: Yup.string()
    .max(264, 'PayPal Sandbox Webhook ID should not exceed 264 characters')
    .notRequired(),
  PAYPAL_LIVE_WEBHOOK_ID: Yup.string()
    .max(264, 'PayPal Live Webhook ID should not exceed 264 characters')
    .notRequired()
});

export const ValidateVeem = Yup.object().shape({
  VEEM_MODE: Yup.string()
    .oneOf(['sandbox', 'live'], 'Invalid Veem mode')
    .required('Veem mode is required'),
  VEEM_SANDBOX_CLIENT_ID: Yup.string().when('VEEM_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Veem Sandbox Client ID should not exceed 4 characters')
        .max(264, 'Veem Sandbox Client ID should not exceed 264 characters')
        .required('Veem Sandbox Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  VEEM_SANDBOX_CLIENT_SECRET: Yup.string().when('VEEM_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Veem Sandbox Client Secret should not exceed 4 characters')
        .max(264, 'Veem Sandbox Client Secret should not exceed 264 characters')
        .required('Veem Sandbox Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  VEEM_LIVE_CLIENT_ID: Yup.string().when('VEEM_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Veem Live Client ID should not exceed 4 characters')
        .max(264, 'Veem Live Client ID should not exceed 264 characters')
        .required('Veem Live Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  VEEM_LIVE_CLIENT_SECRET: Yup.string().when('VEEM_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Veem Live Client Secret should not exceed 4 characters')
        .max(264, 'Veem Live Client Secret should not exceed 264 characters')
        .required('Veem Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  })
});

export const ValidateBankOfAmerica = Yup.object().shape({
  BANK_OF_AMERICA_MODE: Yup.string()
    .oneOf(['sandbox', 'live'], 'Invalid Bank of America mode')
    .required('Bank of America mode is required'),

  BANK_OF_AMERICA_SANDBOX_APPLICATION_ID: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Sandbox Application ID should not exceed 4 characters')
        .max(264, 'Bank of America Sandbox Application ID should not exceed 264 characters')
        .required('Sandbox Application ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  BANK_OF_AMERICA_SANDBOX_CLIENT_ID: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Sandbox Client ID should not exceed 4 characters')
        .max(264, 'Bank of America Sandbox Client ID should not exceed 264 characters')
        .required('Sandbox Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  BANK_OF_AMERICA_SANDBOX_CLIENT_SECRET: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'sandbox',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Sandbox Client Secret should not exceed 4 characters')
        .max(264, 'Bank of America Sandbox Client Secret should not exceed 264 characters')
        .required('Bank of America Sandbox Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  BANK_OF_AMERICA_LIVE_APPLICATION_ID: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Live Application ID should not exceed 4 characters')
        .max(264, 'Bank of America Live Application ID should not exceed 264 characters')
        .required('Live Application ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  BANK_OF_AMERICA_LIVE_CLIENT_ID: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Live Client ID should not exceed 4 characters')
        .max(264, 'Bank of America Live Client ID should not exceed 264 characters')
        .required('Live Client ID cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  }),
  BANK_OF_AMERICA_LIVE_CLIENT_SECRET: Yup.string().when('BANK_OF_AMERICA_MODE', {
    is: (value) => value === 'live',
    then: (schema) =>
      schema
        .min(4, 'Bank of America Live Client Secret should not exceed 4 characters')
        .max(264, 'Bank of America Live Client Secret should not exceed 264 characters')
        .required('Live Client Secret cannot be empty'),
    otherwise: (schema) => schema.notRequired()
  })
});

export const ValidateReportClient = Yup.object().shape({
  client: Yup.array().min(1, 'At least one client is required'),
  financial_year: Yup.string().required('Financial Year cannot be empty'),
  currency: Yup.object().required('Currency cannot be empty')
});

export const ValidateReportDepartment = Yup.object().shape({
  // department: Yup.array().min(1, 'At least one department is required'),
  financial_year: Yup.string().required('Financial Year cannot be empty'),
  currency: Yup.object().required('Currency cannot be empty')
});

export const ValidateAuthorize = Yup.object().shape({
  card_holder_name: Yup.string()
    .max(64, 'Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Name should contain only Alphabets')
    .required('Name cannot be empty'),
  card_number: Yup.string()
    .min(13, 'Card Number should atleast contain 12 characters')
    .max(22, 'Card Number exceed 19 characters')
    .required('Card Number cannot be empty'),
  cvc: Yup.string()
    .min(3, 'CVC Number should atleast contain 3 characters')
    .max(4, 'CVC Number should not exceed 4 characters')
    .required('CVC Number cannot be empty'),
  expiry: Yup.string()
    .matches(/^(0[1-9]|1[0-2])\/\d{4}$/, 'Invalid date format, use MM/YYYY')
    .required('Expiry date is required'),
  address_1: Yup.string()
    .min(8, 'Address should atleast contain 8 characters')
    .max(60, 'Address should not exceed 60 characters')
    .required('Address cannot be empty'),
  city: Yup.string()
    .max(32, 'City cannot exceed 32 characters')
    .min(4, 'City should at least contain 4 characters')
    .matches(/^[a-zA-Z\s]+$/, 'City should contain only Alphabets')
    .required('City cannot be empty'),
  state: Yup.object().required('State cannot be empty'),
  country: Yup.object().required('Country cannot be empty'),
  zip_code: Yup.string()
    .min(1, 'Postal Code should at least contain 1 characters')
    .max(14, 'Postal Code cannot exceed 14 characters')
    .required('Postal Code cannot be empty')
  // .matches(/^[0-9]+$/, "Postal Code should contain only Numeric's")
  // .max(6, 'Postal Code cannot exceed 6 characters')
  // .min(5, 'Postal Code should at least contain 5 characters')
  // .required('Postal Code cannot be empty')
});

export const ValidateStripeCard = Yup.object().shape({
  holder_name: Yup.string()
    .max(64, 'Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Name should contain only Alphabets')
    .required('Name cannot be empty'),
  address_1: Yup.string()
    .min(8, 'Address should atleast contain 8 characters')
    .max(60, 'Address should not exceed 60 characters')
    .required('Address cannot be empty'),
  city: Yup.string()
    .max(32, 'City cannot exceed 32 characters')
    .min(4, 'City should at least contain 4 characters')
    .matches(/^[a-zA-Z\s]+$/, 'City should contain only Alphabets')
    .required('City cannot be empty'),
  state: Yup.object().required('State cannot be empty'),
  country: Yup.object().required('Country cannot be empty'),
  zip_code: Yup.string()
    .min(1, 'Postal Code should at least contain 1 characters')
    .max(14, 'Postal Code cannot exceed 14 characters')
    .required('Postal Code cannot be empty')
  // .matches(/^[0-9]+$/, "Postal Code should contain only Numeric's")
  // .max(6, 'Postal Code cannot exceed 6 characters')
  // .min(5, 'Postal Code should at least contain 5 characters')
  // .required('Postal Code cannot be empty')
});

export const ValidateWriteoffManualPayment = Yup.object().shape({
  message: Yup.string()
    .max(128, 'Message cannot exceed 128 characters')
    .min(2, 'Message should at least contain 2 characters')
    .required('Message cannot be empty'),
  amount: Yup.number()
    .max(99999999, 'Amount cannot exceed 8 characters')
    .min(1, 'Amount should at least contain 1 characters')
    .required('Amount cannot be empty'),
  payment_gateway: Yup.string()
    .max(32, 'Payment Method cannot exceed 32 characters')
    .min(4, 'Payment Method can only contain alphabets, spaces, dots, and ampersands')
    .matches(
      /^[a-zA-Z. &]*$/,
      'Payment Method can only contain alphabets, spaces, dots, and ampersands'
    )
    .required('Payment Method cannot be empty'),
  transaction_id: Yup.string()
    .max(264, 'Transaction ID cannot exceed 264 characters')
    .min(4, 'Transaction ID should at least contain 4 characters')
    .matches(
      /^[A-Za-z0-9\-_.]{1,128}$/,
      'Transaction ID must be contain only alphabets and numbers and special characters[. _ -]'
    )
    .required('Transaction ID cannot be empty')
});

export const ValidateWriteoffPaymentReason = Yup.object().shape({
  reason: Yup.string()
    .max(128, 'Reason cannot exceed 128 characters')
    .min(2, 'Reason should at least contain 2 characters')
    .required('Reason cannot be empty')
});

export const ValidateSignature = Yup.object().shape({
  name: Yup.string()
    .max(32, 'Name cannot exceed 32 characters')
    .min(4, 'Name should at least contain 4 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Name should contain only Alphabets')
    .required('Name cannot be empty')
});

export const validationCloverForm = Yup.object({
  first_name: Yup.string()
    .min(2, 'First Name should at least contain 2 characters')
    .max(64, 'First Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'First Name should contain only Alphabets')
    .required('First Name cannot be empty'),
  last_name: Yup.string()
    .min(2, 'Last Name should at least contain 2 characters')
    .max(64, 'Last Name cannot exceed 64 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Last Name should contain only Alphabets')
    .required('Last Name cannot be empty'),
  email: Yup.string()
    .matches(emailValidationRegex, 'Enter a valid Email ID')
    .max(64, 'Email ID cannot exceed 64 characters')
    .min(5, 'Email ID should at least contain 5 characters')
    .required('Email ID cannot be empty'),
  phone: Yup.string()
    .max(16, 'Phone Number cannot exceed 16 characters')
    .min(4, 'Phone Number should at least contain 4 characters')
    .matches(phoneRegex, 'Please enter a valid Phone Number')
    .required('Phone Number cannot be empty')
});
